import { useCallback, useEffect } from "react";

export const useScrollHandler = ({
  incrementPageNumber,
  setOnScroll,
  hasMore,
  setHasMore,
  loading,
  data,
  pageNumber,
}) => {
  let isScrolling = false;
  let lastScrollTop = 0;
  let scrollTimeout: ReturnType<typeof setTimeout> | null = null;

  const handleScroll = useCallback(() => {
    if (isScrolling || loading) return;

    const currentScrollTop = document.documentElement.scrollTop;
    const scrollPosition = window.innerHeight + currentScrollTop;
    const threshold = document.documentElement.offsetHeight - 500;

    if (scrollTimeout) clearTimeout(scrollTimeout);

    scrollTimeout = setTimeout(() => {
      // Check if user is scrolling down
      if (scrollPosition >= threshold && currentScrollTop > lastScrollTop) {
        isScrolling = true;
        setOnScroll(true);
        // Increase pagenumber only if there are more documents to fetch
        if (hasMore) {
          incrementPageNumber();
        }
        if (!hasMore) {
          isScrolling = false;
          setOnScroll(false);
        }
      }
      lastScrollTop = currentScrollTop; // Update last scroll position
    }, 900);
  }, [loading, hasMore]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  useEffect(() => {
    // Doesnt fetch more documents from API
    if (data?.searchDocumentsResponse?.length === 0) {
      setHasMore(false);
    }
    // When we change the document type we set this to TRUE so API can be called again
    if (pageNumber === 0) {
      setHasMore(true);
    }
  }, [data, pageNumber]);

  return handleScroll;
};
